import { useEffect, useState } from "react";
import { api } from "@/api";
import Overlay from "@/components/Overlay";
import CatalogueBuilder from "./CatalogueBuilder";
import { X, Plus, BookOpen } from "lucide-react";

export default function AddToCatalogue({ productIds, credits, setCredits, costs, onClose, onDone }) {
  const [cats, setCats] = useState(null);
  const [target, setTarget] = useState(undefined);

  useEffect(() => { api.get("/exhibitor/catalogues").then(({ data }) => setCats(data.filter((c) => c.type !== "pdf"))); }, []);

  if (target !== undefined) {
    return <CatalogueBuilder catalogueId={target} appendIds={productIds} credits={credits} setCredits={setCredits} costs={costs} onClose={onClose} onSaved={onDone} />;
  }
  return (
    <Overlay onClose={onClose} testid="add-to-catalogue-modal">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-2xl gold-text">Add {productIds.length} to…</h3>
        <button onClick={onClose} className="text-slate-400" data-testid="add-to-catalogue-close"><X size={20} /></button>
      </div>
      <button onClick={() => setTarget(null)} className="w-full mt-4 btn-gold py-3 rounded-xl flex items-center justify-center gap-2" data-testid="add-to-new-catalogue"><Plus size={16} /> New catalogue</button>
      <div className="space-y-2 mt-4">
        {(cats || []).map((c) => (
          <button key={c.id} onClick={() => setTarget(c.id)} className="w-full glass rounded-xl p-3 flex items-center gap-3 text-left border border-amber-500/15" data-testid={`add-to-catalogue-${c.id}`}>
            <BookOpen size={16} className="text-amber-400" />
            <span className="flex-1 text-sm text-slate-200 truncate">{c.title}</span>
            <span className="text-[10px] uppercase text-slate-500">{c.status === "draft" ? "Draft" : "Published"}</span>
          </button>
        ))}
      </div>
    </Overlay>
  );
}
